export interface StatItem {
  label: string;
  value: string;
}

export const STATS: StatItem[] = [
  { label: "Partner Fishermen", value: "60+" },
  { label: "Avg. Delivery Time", value: "18hrs" },
  { label: "Catch Traceability", value: "100%" },
  { label: "Middlemen", value: "0" },
];
